import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import {
  MainVuexState,
  ConfigNodeBasicInfo,
  ConfigNodeInsertInfo,
  ConfigMetaData,
} from '../types'
import Utils from '@/lib/utils'
import MapToJSONParser from '@/store/helpers/MapToJSONParser'
import GlobalService from '@/services/GlobalService'
import SnippetCreator from '@/store/helpers/SnippetCreator'

Vue.use(Vuex)
var cloneDeep = require('lodash.clonedeep')

let numberSequences = 0
let numberModules = 0
//Vue.use(VueLodash, { name: 'custom', lodash: { random } })

/* async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
} */

const state: MainVuexState = {
  dbNames: [],
  configMetaData: { database: '', name: '' },
  JSONconfiguration: {}, //JSON data from server/to save on server
  //selected node information
  JSONconfigurationList: {},
  taskStatus: '', //currently either PENDING or ''
  selectedNodeType: '',
  selectedNodeName: '',
  selectedNodeCType: '',
  selectedNodeId: -1,
  selectedNodeParamLength: 0,
  selectedNodeParentId: 0,
  selectedNodeParentParentId: 0,
  treeRefsMap: {}, //map holding all tree refs
  configNodesMap: {}, //Main map used to map IDs to the Object objects
  topLevelNodeTypeToIdMap: {}, //1-many Top Level Node Type to array of Top Level IDs map
  topLevelNodeNameToIdMap: {}, //1-1 Top Level Node Name to Top Level ID map
  topLevelNodeNameReferenceIDsMap: {}, //1-many Top Level Node Name to Set of reference IDs map
  topLevelModuleNameToChildrenIDsMap: {},
  //Datasets and streams
  topLevelStreamNameToIdMap: {}, //1-1 Top Level Stream Name to Top Level ID map
  topLevelDatasetNameToIdMap: {}, //1-1 Top Level Dataset Name to Top Level ID map
  topLevelStreamNameReferenceIDsMap: {}, //both Streams and Datasets can have same name so we separate IDs
  topLevelDataSetsNameReferenceIDsMap: {},
  //root node IDs
  rootNodeIds: {},
  //node ID to Object map containing all information about every configuration
  configsListNodeMap: {},
  //arrays with node id's - open nodes and forced open nodes
  openNodeIds: [],
  forcedOpenNodeIds: [],
  forcedActiveNodeType: '',
  forcedActiveNodeId: 0,
  //content of the opened JSON file
  openFileContent: '',
  //content of the saved JSON file
  savedFileContent: '',
  darkMode: false,
  //global node ID counter
  idCounter: 0,
  //global configs node ID counter
  configsIdCounter: 0,
  //snackbar variables
  snackBarOpen: false,
  snackBarText: '',
  snackBarColor: '',
  startLoadingConfig: false,
  configLoaded: false,
  configsListLoaded: false,
  prescaleTableHeaders: [],
  prescaleTableRows: [],
}

export default new Vuex.Store({
  state,
  mutations: {
    SET_SELECTED_NODE_VIA_ID(state: MainVuexState, payload) {
      //console.log('SET_SELECTED_NODE_VIA_ID : ' + payload.selectedNodeId)

      let referenceNode =
        payload.selectedNodeId ==
        state.configNodesMap[payload.selectedNodeId].rootNodeId
          ? false
          : true

      state.selectedNodeId = payload.selectedNodeId

      //get all info just via ID
      state.selectedNodeType = state.configNodesMap[state.selectedNodeId].type
      state.selectedNodeName = state.configNodesMap[state.selectedNodeId].name
      state.selectedNodeCType = state.configNodesMap[state.selectedNodeId].ctype
      if (state.configNodesMap[state.selectedNodeId].children != undefined)
        state.selectedNodeParamLength =
          state.configNodesMap[state.selectedNodeId].children.length
      else {
        state.selectedNodeParamLength =
          state.topLevelModuleNameToChildrenIDsMap[state.selectedNodeName].size
      }

      if (!referenceNode)
        state.selectedNodeParentId =
          state.configNodesMap[state.selectedNodeId].parentNodeId
      else {
        state.selectedNodeParentId =
          state.configNodesMap[state.selectedNodeId].parentNodeId
        state.selectedNodeParentParentId =
          state.configNodesMap[state.selectedNodeParentId].parentNodeId
      }
      let forceOpenNode = payload.forceOpenNode //if node is opened by force open it's parent as well

      let idIndex = -1
      if (forceOpenNode) {
        /*       console.log(
          'FORCED NODE: ' +
            JSON.stringify(state.configNodesMap[state.selectedNodeId])
        ) */

        state.forcedActiveNodeType = state.selectedNodeType
        state.forcedActiveNodeId = state.selectedNodeId
        //console.log('FORCED NODE TYPE: ' + state.forcedActiveNodeType)
        //console.log('FORCED NODE ID: ' + state.forcedActiveNodeId)
      } else {
        state.forcedActiveNodeType = ''
        state.forcedActiveNodeId = 0
      }
      idIndex = state.openNodeIds.indexOf(state.selectedNodeId)

      if (idIndex == -1) {
        if (forceOpenNode) {
          //if force is enwoked both node and it's parent have to be opened
          let parentNodeIndex = state.openNodeIds.indexOf(
            state.selectedNodeParentId
          )
          let parentParentNodeIndex = -1
          if (referenceNode) {
            parentParentNodeIndex = state.openNodeIds.indexOf(
              state.selectedNodeParentParentId
            )
          }

          if (parentNodeIndex == -1) {
            //push parent node on array as well
            state.openNodeIds.push(state.selectedNodeParentId)
          }
          if (referenceNode && parentParentNodeIndex == -1) {
            //if reference push parent's parent on array as well (hopefully only 2 levels)
            state.openNodeIds.push(state.selectedNodeParentParentId)
          }
        }
        state.openNodeIds.push(state.selectedNodeId)
      } else {
        if (forceOpenNode) {
          //if force is enwoked both node and it's parent have to be opened
          let parentNodeIndex = state.openNodeIds.indexOf(
            state.selectedNodeParentId
          )
          if (parentNodeIndex == -1) {
            //push parent node on array as well
            state.openNodeIds.push(state.selectedNodeParentId)
          }
        }
        if (!forceOpenNode) {
          state.openNodeIds.splice(idIndex, 1) //close the node if already open (not if forced)
        }
      }
      //console.log('OPEN: ' + state.openNodeIds)
      if (forceOpenNode) {
        state.forcedOpenNodeIds = [...state.openNodeIds] //cannot assign by reference, but copy whole array
      }
    },
    SET_SELECTED_NODE_FOCUS_VIA_ID(state: MainVuexState, payload) {},
    SET_TREEREFS_MAP(state: MainVuexState, payload: Object) {
      state.treeRefsMap = payload
    },
    SET_CONFIG_NODES_MAP(state: MainVuexState, payload: Object) {
      state.configNodesMap = Object.freeze(payload)
      //state.dummyObject = Object.freeze(payload)
    },
    SET_CONFIGS_LIST_NODES_MAP(state: MainVuexState, payload: Object) {
      state.configsListNodeMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_NODE_NAME_TO_IDS(state: MainVuexState, payload: Object) {
      state.topLevelNodeNameToIdMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_DATESET_NAME_TO_IDS(state: MainVuexState, payload: Object) {
      state.topLevelDatasetNameToIdMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_STREAM_NAME_TO_IDS(state: MainVuexState, payload: Object) {
      state.topLevelStreamNameToIdMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_NODE_TYPE_TO_IDS(state: MainVuexState, payload: Object) {
      state.topLevelNodeTypeToIdMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_NODE_NAME_REFERENCE_IDS(
      state: MainVuexState,
      payload: Object
    ) {
      state.topLevelNodeNameReferenceIDsMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_DATASET_NAME_REFERENCE_IDS(
      state: MainVuexState,
      payload: Object
    ) {
      state.topLevelDataSetsNameReferenceIDsMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_STREAM_NAME_REFERENCE_IDS(
      state: MainVuexState,
      payload: Object
    ) {
      state.topLevelStreamNameReferenceIDsMap = Object.freeze(payload)
    },
    SET_TOP_LEVEL_MODULE_NAME_TO_CHILDREN_IDS(
      state: MainVuexState,
      payload: Object
    ) {
      state.topLevelModuleNameToChildrenIDsMap = Object.freeze(payload)
    },
    SET_ROOT_NODE_IDS(state: MainVuexState, payload: Object) {
      state.rootNodeIds = Object.freeze(payload)
      //console.log(JSON.stringify(state.rootNodeIds))
    },
    CREATE_NODE_ID_TO_OBJECT_REFERENCES(state: MainVuexState) {
      //console.log('NODES NUMBER BEFORE REFERENCING: ' + state.idCounter)

      //go through all top level nodes
      //console.log('MAIN MAP FROZEN: ' + Object.isFrozen(state.configNodesMap))
      let startTime = performance.now()
      let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)
      let topLevelNodeNameReferenceIDsMapCopy: Object = cloneDeep(
        state.topLevelNodeNameReferenceIDsMap
      )
      let topLevelDatasetNameReferenceIDsMapCopy: Object = cloneDeep(
        state.topLevelDataSetsNameReferenceIDsMap
      )
      let topLevelStreamNameReferenceIDsMapCopy: Object = cloneDeep(
        state.topLevelStreamNameReferenceIDsMap
      )
      let endTime = performance.now()

      console.log(
        `CREATE_NODE_ID_TO_OBJECT_REFERENCES cloneDeep took ${endTime -
          startTime} milliseconds`
      )

      /*       console.log(
        'topLevelDatasetNameReferenceIDsMapCopy:' +
          JSON.stringify(topLevelDatasetNameReferenceIDsMapCopy)
      ) */

      for (const [nodeName, nodeId] of Object.entries(
        state.topLevelNodeNameToIdMap
      )) {
        if (topLevelNodeNameReferenceIDsMapCopy[nodeName] == undefined) continue

        topLevelNodeNameReferenceIDsMapCopy[nodeName].forEach(
          (referenceNodeId) => {
            nodeObjectMapCopy[referenceNodeId].rootNodeId = nodeId
          }
        )
      }

      //console.log('NODES NUMBER BEFORE DEEP REFERENCING: ' + state.idCounter)
      /*      console.log(
        'MAP SIZE BEFORE DEEP REFERENCING: ' +
          Utils.roughSizeOfObject(nodeObjectMapCopy)
      ) */
      //return
      for (const [topLevelType, topLevelIDArray] of Object.entries(
        state.topLevelNodeTypeToIdMap
      )) {
        //console.log('KEY: ' + topLevelType)
        //console.log('VALUE: ' + value)
        let idArray = topLevelIDArray as Array<number>

        for (const [nodeName, nodeId] of Object.entries(idArray)) {
          if (
            nodeObjectMapCopy[nodeId].type == 'sequences' ||
            nodeObjectMapCopy[nodeId].type == 'paths' ||
            nodeObjectMapCopy[nodeId].type == 'tasks' ||
            nodeObjectMapCopy[nodeId].type == 'conditionaltasks' ||
            nodeObjectMapCopy[nodeId].type == 'stream' ||
            nodeObjectMapCopy[nodeId].type == 'dataset'
          ) {
            if (
              nodeObjectMapCopy[nodeId].children == undefined ||
              nodeObjectMapCopy[nodeId].children.length == 0
            )
              continue

            recursevlyCopyChildren(
              nodeId,
              nodeObjectMapCopy[nodeId].children,
              nodeObjectMapCopy,
              topLevelNodeNameReferenceIDsMapCopy,
              topLevelDatasetNameReferenceIDsMapCopy,
              topLevelStreamNameReferenceIDsMapCopy
            )
          }
        }
      }

      //console.log('NODES NUMBER AFTER REFERENCING: ' + state.idCounter)
      /*       console.log(
        'MAP SIZE AFTER DEEP REFERENCING: ' +
          Utils.roughSizeOfObject(nodeObjectMapCopy)
      ) */

      //console.log('SEQUNCE REFERENCE NODES: ' + numberSequences)
      //console.log('MODULE REFERENCE NODES: ' + numberModules)

      state.topLevelNodeNameReferenceIDsMap = Object.freeze(
        topLevelNodeNameReferenceIDsMapCopy
      )
      state.topLevelDataSetsNameReferenceIDsMap = Object.freeze(
        topLevelDatasetNameReferenceIDsMapCopy
      )
      state.topLevelStreamNameReferenceIDsMap = Object.freeze(
        topLevelStreamNameReferenceIDsMapCopy
      )
      state.configNodesMap = Object.freeze(nodeObjectMapCopy)
    },
    DELETE_NODE_ID_TO_OBJECT_REFERENCES(state: MainVuexState) {
      let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)
      deleteChildrenReferencesHelper(nodeObjectMapCopy, {})
      state.configNodesMap = Object.freeze(nodeObjectMapCopy)
    },
    SET_DB_NAMES(state: MainVuexState, payload: Array<string>) {
      state.dbNames = payload
    },
    SET_CONFIG_METADATA(state: MainVuexState, payload: ConfigMetaData) {
      state.configMetaData = Object.assign(payload)
    },
    SET_JSON_CONFIGURATION(state: MainVuexState, payload) {
      state.JSONconfiguration = Object.freeze(payload)
    },
    SET_TASK_STATUS(state: MainVuexState, payload: string) {
      state.taskStatus = payload
      //console.log('JSON: ' + JSON.stringify(state.JSONconfiguration))
    },
    SET_JSON_CONFIGURATION_LIST(state: MainVuexState, payload) {
      state.JSONconfigurationList = Object.freeze(payload)
      //console.log('JSON: ' + JSON.stringify(state.JSONconfigurationList))
    },
    DELETE_JSON_CONFIGURATION(state: MainVuexState) {
      state.JSONconfiguration = {}
      state.configNodesMap = {}
      state.taskStatus = ''
      //state.openFileContent = '' //TODO: fix this
      state.topLevelNodeNameReferenceIDsMap = {}
      state.topLevelModuleNameToChildrenIDsMap = {}
      state.topLevelNodeNameToIdMap = {}
      state.topLevelNodeTypeToIdMap = {}
    },
    ADD_NODE(state: MainVuexState, payload) {
      /*       console.log('ADD_NODE')
      console.log(
        'payload.nodeIDToObject' + JSON.stringify(payload.nodeIDToObject)
      )
      console.log('payload.id ' + payload.nodeId)
      console.log(
        'payload.nodeIDToObject.parentNodeId ' +
          payload.nodeIDToObject.parentNodeId
      ) */
      //shallow copy - DOESN'T WORK
      //let copy: Object = { ...state.configNodesMap }
      //TODO: this is a bit slow, can it be faster?
      let t0 = performance.now()

      let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)
      //add new node both to children of the parent and in the main map
      let topLevelNodeNameToIdMapCopy: Object = cloneDeep(
        state.topLevelNodeNameToIdMap
      )
      let topLevelNodeTypeToIdMapCopy: Object = cloneDeep(
        state.topLevelNodeTypeToIdMap
      )

      //insert new child into the map
      nodeObjectMapCopy[payload.nodeIDToObject.parentNodeId].children.push(
        payload.nodeIDToObject
      )
      nodeObjectMapCopy[payload.nodeId] = payload.nodeIDToObject
      console.log('TYPE: ' + payload.type)
      //insert new child into the top level name - id map
      topLevelNodeNameToIdMapCopy[payload.name] = payload.nodeId
      topLevelNodeTypeToIdMapCopy[payload.nodeIDToObject.type].push(
        payload.nodeId
      )
      /*   deleteChildrenReferencesHelper(
        nodeObjectMapCopy,
        topLevelNodeNameToIdMapCopy
      ) */

      state.configNodesMap = Object.freeze(nodeObjectMapCopy)
      state.topLevelNodeNameToIdMap = Object.freeze(topLevelNodeNameToIdMapCopy)
      state.topLevelNodeTypeToIdMap = Object.freeze(topLevelNodeTypeToIdMapCopy)
      let t1 = performance.now()
      console.log(
        'ADD CLONEDEEP TOOK: ' + Math.round(t1 - t0) / 1000 + ' seconds'
      )
      /*     console.log(
        'Last child 2:' +
          JSON.stringify(
            state.configNodesMap[payload.nodeIDToObject.parentNodeId]
              .children[childrenLen - 1]
          )
      ) */
      //console.log('ADDITION DONE')
    },
    RENAME_NODE(state: MainVuexState, payload) {
      let startTime = performance.now()

      let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)
      let topLevelNodeNameReferenceIDsMapCopy: Object = cloneDeep(
        state.topLevelNodeNameReferenceIDsMap
      )

      let endTime = performance.now()
      console.log(
        `RENAME_NODE cloneDeep took ${endTime - startTime} milliseconds`
      )

      //get the root name ID
      let oldName = nodeObjectMapCopy[payload.rootNodeId].name
      topLevelNodeNameReferenceIDsMapCopy[oldName].forEach(
        (referenceNodeId) => {
          nodeObjectMapCopy[referenceNodeId].name = payload.newNodeName
          console.log('REF ID: ' + referenceNodeId)
        }
      )
      topLevelNodeNameReferenceIDsMapCopy[payload.newNodeName] = new Set(
        topLevelNodeNameReferenceIDsMapCopy[oldName]
      )
      nodeObjectMapCopy[payload.rootNodeId].name = payload.newNodeName
      delete topLevelNodeNameReferenceIDsMapCopy[oldName]

      deleteChildrenReferencesHelper(nodeObjectMapCopy, {})

      state.topLevelNodeNameReferenceIDsMap = Object.freeze(
        topLevelNodeNameReferenceIDsMapCopy
      )
      state.configNodesMap = Object.freeze(nodeObjectMapCopy)
    },
    DELETE_NODE(state: MainVuexState, payload) {
      let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)

      let nodeToDelete = nodeObjectMapCopy[payload.nodeId] as Object
      //delete nodeId from topLevelNodeTypeToIdMap
      //console.log('PROBLEMATIC NODE: ' + JSON.stringify(nodeObjectMapCopy[5]))

      //let problemID = 17087

      for (
        //go through all top level node IDs of a particular type
        let i = 0;
        i < state.topLevelNodeTypeToIdMap[nodeToDelete['type']].length;
        i++
      ) {
        if (
          state.topLevelNodeTypeToIdMap[nodeToDelete['type']][i] ==
          nodeToDelete['id']
        ) {
          /*      console.log('FOUND AND SPLICED: ' + i)
          console.log('BEFORE: ' + state.topLevelNodeTypeToIdMap[nodeToDelete.type]) */
          state.topLevelNodeTypeToIdMap[nodeToDelete['type']].splice(i, 1)
          //console.log('AFTER: ' + state.topLevelNodeTypeToIdMap[nodeToDelete.type]) //this is OK
        }
      }
      //console.log('NODE TO DELETE: ' + JSON.stringify(nodeToDelete))
      //first delete references to node's children as well as children nodes
      //console.log('NODE CHILDREN: ' + nodeToDelete.children)
      for (const [nodeId, childNodeObject] of Object.entries(
        nodeToDelete['children']
      ) as any) {
        //console.log('KEY: ' + nodeId)
        //console.log('VALUE: ' + JSON.stringify(childNodeObject))
        //take rootNodeId of each child, go to that node and delete reference to this child
        let childIdToDelete = childNodeObject['id']
        let rootNodeId = childNodeObject['rootNodeId']
        //console.log('CHILD TO DELETE: ' + childIdToDelete)
        //console.log('ROOT NODE ID: ' + rootNodeId)
        /*         console.log(
          'ROOT NODE REFERENCES BEFORE DELETE: ' +
            nodeObjectMapCopy[rootNodeId].referencedByIds
        ) */
        //console.log('childIdToDelete: ' + childIdToDelete)
        let nonTopLevelReferenceIDs =
          state.topLevelNodeNameReferenceIDsMap[
            nodeObjectMapCopy[rootNodeId].name
          ] //get all references of a node name

        const referenceIndex = nodeObjectMapCopy[
          rootNodeId
        ].referencedByIds.indexOf(childIdToDelete)
        const referenceIndex1 = nonTopLevelReferenceIDs.indexOf(childIdToDelete)
        /*         console.log('referenceIndex: ' + referenceIndex)
        console.log('rootNodeId: ' + rootNodeId)
        console.log(
          'nodeObjectMapCopy[rootNodeId].referencedByIds: ' +
            nodeObjectMapCopy[rootNodeId].referencedByIds
        )
        console.log('nonTopLevelReferenceIDs ' + nonTopLevelReferenceIDs) */
        if (referenceIndex > -1) {
          nodeObjectMapCopy[rootNodeId].referencedByIds.splice(
            referenceIndex,
            1
          )
          nonTopLevelReferenceIDs.splice(referenceIndex1, 1)
        }
        /*         console.log(
          'nodeObjectMapCopy[rootNodeId].referencedByIds: ' +
            nodeObjectMapCopy[rootNodeId].referencedByIds
        )
        console.log('nonTopLevelReferenceIDs ' + nonTopLevelReferenceIDs) */

        //delete child from children array
        /* console.log(
          'NODE CHILDREN BEFORE: ' + JSON.stringify(nodeToDelete.children)
        ) */
        //const childIndex = nodeToDelete.children.indexOf(childIdToDelete)
        //if (childIndex > -1) {
        nodeToDelete['children'].splice(0, 1) //delete one child by one child
        //}
        //delete child from the map as well
        /*  console.log(
          'CHILD NODE BEFORE DELETE FROM MAP: ' +
            nodeObjectMapCopy[childIdToDelete]
        ) */
        delete nodeObjectMapCopy[childIdToDelete]
        /*  console.log(
          'CHILD NODE AFTER DELETE FROM MAP: ' +
            nodeObjectMapCopy[childIdToDelete]
        ) */

        /* console.log(
          'NODE CHILDREN AFTER: ' + JSON.stringify(nodeToDelete.children)
        ) */

        /*         console.log(
          'ROOT NODE REFERENCES AFTER DELETE: ' +
            nodeObjectMapCopy[rootNodeId].referencedByIds
        ) */
      }
      //then delete main node and all it's references (references first)
      //we can assume that references have no children but are just a mirror of the root node (for now)
      for (let i = 0; i < nodeToDelete['referencedByIds'].length; i++) {
        //first we have to delete node from the children of it's parent node so it reflects in gui
        //then we have to delete the node object from the map
        //console.log('REFERENCE NODE ID: ' + nodeToDelete.referencedByIds[i])
        //get the parent node id of the reference
        let referenceParentNodeId =
          nodeObjectMapCopy[nodeToDelete['referencedByIds'][i]].parentNodeId
        //console.log('REFERENCE PARENT NODE ID: ' + referenceParentNodeId)
        let childIndex = 0
        for (const [key, referenceParentChildNodeObject] of Object.entries(
          nodeObjectMapCopy[referenceParentNodeId].children as Object
        )) {
          //console.log('REFERENCE PARENT CHILD KEY: ' + key)
          /*      console.log(
            'REFERENCE PARENT CHILD VALUE: ' + referenceParentChildNodeObject
          ) */
          //if referenceParentChildNodeObject.id is the reference id splice that child from the parent
          if (
            referenceParentChildNodeObject.id ==
            nodeToDelete['referencedByIds'][i]
          ) {
            nodeObjectMapCopy[referenceParentNodeId].children.splice(
              childIndex,
              1
            )
            //then we have to delete the node object from the map
            delete nodeObjectMapCopy[referenceParentChildNodeObject.id]
          }
          childIndex++
        }
      }
      //now we can delete the root node (first from it's parents children and then from the map)
      let parentId = nodeToDelete['parentNodeId']
      //console.log('PARENT ID: ' + parentId)
      let childIndex = 0
      for (const [key, parentChildNodeObject] of Object.entries(
        nodeObjectMapCopy[parentId].children as Object
      )) {
        if (parentChildNodeObject.id == nodeToDelete['id']) {
          nodeObjectMapCopy[parentId].children.splice(childIndex, 1)
          //then we have to delete the node object from the map
          delete nodeObjectMapCopy[parentChildNodeObject.id]
          break
        }
        childIndex++
      }

      /*    console.log(
        'nodeObjectMapCopy[problemID].referencedByIds: ' + nodeObjectMapCopy[problemID].referencedByIds
      ) */

      deleteChildrenReferencesHelper(nodeObjectMapCopy, {})

      state.configNodesMap = Object.freeze(nodeObjectMapCopy)
    },
    INSERT_NODE_REFERENCES_OR_CLONE(state: MainVuexState, payload) {
      let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)
      let topLevelNodeNameReferenceIDsMapCopy: Object = cloneDeep(
        state.topLevelNodeNameReferenceIDsMap
      )
      for (let i = 0; i < payload.length; i++) {
        if (payload[i].cloneName == '')
          insertNodeReferenceHelper(
            nodeObjectMapCopy,
            topLevelNodeNameReferenceIDsMapCopy,
            payload[i]
          )
        else {
          //clone and insert reference
          cloneNodeHelper(
            nodeObjectMapCopy,
            topLevelNodeNameReferenceIDsMapCopy,
            payload[i]
          )
        }
      }
      state.topLevelNodeNameReferenceIDsMap = Object.freeze(
        topLevelNodeNameReferenceIDsMapCopy
      )
      state.configNodesMap = Object.freeze(nodeObjectMapCopy)
    },
    TEST_ACTION(state: MainVuexState, payload) {
      //console.log(JSON.stringify(state.configNodesMap[1]))
      state.configNodesMap[1]['name'] = 'AAA'
      //console.log(JSON.stringify(state.configNodesMap[1]))
    },
    SET_INITIAL_ID_COUNTER(state: MainVuexState, payload: number) {
      //console.log('SETTING INITIAL ID COUNTER: ' + payload)
      state.idCounter = payload
    },
    SET_INITIAL_CONFIGS_ID_COUNTER(state: MainVuexState, payload) {
      //console.log('SETTING INITIAL ID COUNTER: ' + payload)
      state.idCounter = payload
    },
    INCREMENT_ID_COUNTER(state: MainVuexState) {
      //console.log('INCREMENTING ID COUNTER')
      state.idCounter++
    },
    SET_OPEN_FILE_CONTENT(state: MainVuexState, payload) {
      //console.log('SETTING OPEN FILE CONTENT:')
      state.openFileContent = payload
      //console.log('OPEN FILE CONTENT SET:' + payload)
    },
    PARSE_MAP_TO_JSON_FILE(state: MainVuexState) {
      //parse the map here
      state.savedFileContent = MapToJSONParser.parseMapToJSON(
        state.topLevelModuleNameToChildrenIDsMap,
        state.configNodesMap,
        state.rootNodeIds
      )
    },
    SET_DARK_MODE(state: MainVuexState, payload) {
      state.darkMode = payload
    },
    SET_SNACKBAR_TEXT(state: MainVuexState, payload) {
      state.snackBarOpen = true
      //console.log('SNACKBAR COLOR: ' + payload.snackBarColor)
      state.snackBarText = payload.snackBarText
      state.snackBarColor = payload.snackBarColor
      Utils.sleep(4000).then(() => {
        state.snackBarOpen = false
      })
    },
    SET_SNACKBAR_OPEN(state: MainVuexState, payload: boolean) {
      state.snackBarOpen = payload
    },
    SET_CONFIG_LOADED(state: MainVuexState, payload: boolean) {
      //console.log('CONFIG LOADED: ' + payload)
      state.configLoaded = payload
    },
    SET_START_LOADING_CONFIG(state: MainVuexState, payload: boolean) {
      //console.log('CONFIG LOADED: ' + payload)
      state.startLoadingConfig = payload
    },
    SET_CONFIGS_LIST_LOADED(state: MainVuexState, payload: boolean) {
      //console.log('CONFIG LOADED: ' + payload)
      state.configsListLoaded = payload
    },
  },
  actions: {
    createTreeRefsMap({ commit }, payload: Object) {
      commit('SET_TREEREFS_MAP', payload)
    },
    createConfigNodesMap({ commit }, payload: Object) {
      commit('SET_CONFIG_NODES_MAP', payload)
    },
    createConfigsListNodesMap({ commit }, payload: Object) {
      commit('SET_CONFIGS_LIST_NODES_MAP', payload)
    },
    createTopLevelNodeNameToIds({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_NODE_NAME_TO_IDS', payload)
    },
    createTopLevelDatasetNameToIds({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_DATESET_NAME_TO_IDS', payload)
    },
    createTopLevelStreamNameToIds({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_STREAM_NAME_TO_IDS', payload)
    },
    createTopLevelNodeTypeToIds({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_NODE_TYPE_TO_IDS', payload)
    },
    createTopLevelNodeNameReferenceIDsMap({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_NODE_NAME_REFERENCE_IDS', payload)
    },
    createTopLevelDatasetNameReferenceIDsMap({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_DATASET_NAME_REFERENCE_IDS', payload)
    },
    createTopLevelStreamNameReferenceIDsMap({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_STREAM_NAME_REFERENCE_IDS', payload)
    },
    createTopLevelModuleNameChildrenIDsMap({ commit }, payload: Object) {
      commit('SET_TOP_LEVEL_MODULE_NAME_TO_CHILDREN_IDS', payload)
    },
    createRootNodeIds({ commit }, payload: Object) {
      commit('SET_ROOT_NODE_IDS', payload)
    },
    createObjectReferences({ commit }) {
      commit('CREATE_NODE_ID_TO_OBJECT_REFERENCES')
    },
    deleteObjectReferences({ commit }) {
      commit('DELETE_NODE_ID_TO_OBJECT_REFERENCES')
    },
    clearStoreState({ commit }) {
      commit('DELETE_JSON_CONFIGURATION')
    },
    fetchDBNames({ commit, dispatch }) {
      return GlobalService.getDBNames()
        .then((response) => {
          console.log('SET_DB_NAMES: ' + response.data.names)
          commit('SET_DB_NAMES', response.data.names)
        })
        .catch((error) => {
          dispatch('setSnackBarText', {
            snackBarText: error,
            snackBarColor: 'red',
          })
        })
    },
    fetchCfgFromFileOrLocalServer(
      { commit, dispatch },
      payload: { fromFile: boolean; fileData: any }
    ) {
      if (!payload.fromFile) {
        return GlobalService.getCfgFromFileOrLocalServer()
          .then((response) => {
            commit('SET_JSON_CONFIGURATION', response.data)
            //console.log('SEQUENCE JSON DATA: ' + JSON.stringify(response.data))
          })
          .catch((error) => {
            dispatch('setSnackBarText', {
              snackBarText: error,
              snackBarColor: 'red',
            })
          })
      } else {
        let configurationData = GlobalService.getConfigFromLocalFile(
          payload.fileData
        )
        commit('SET_JSON_CONFIGURATION', configurationData)
        //console.log('SEQUENCE FILE DATA: ' + JSON.stringify(sequenesData))
      }
    },
    fetchCfgMetadataFromFileOrLocalServer({ commit, dispatch }) {
      return GlobalService.getMetadataFromFileOrLocalServer()
        .then((response) => {
          console.log('SET_CONFIG_METADATA: ' + response.data.database)
          commit('SET_CONFIG_METADATA', response.data)
        })
        .catch((error) => {
          dispatch('setSnackBarText', {
            snackBarText: error,
            snackBarColor: 'red',
          })
        })
    },
    fetchCfgFromServerByName(
      { commit, dispatch },
      payload: { cfg: string; db: string }
    ) {
      commit('SET_TASK_STATUS', 'PENDING') //INITIAL PENDING

      return GlobalService.getConfigurationByName(payload.cfg, payload.db)
        .then((response) => {
          commit('SET_TASK_STATUS', '')
          commit('SET_JSON_CONFIGURATION', response.data.cfg)
          commit('SET_CONFIG_METADATA', response.data.metadata)
          console.log('METADATA: ' + JSON.stringify(response.data.metadata))
        })
        .catch((error) => {
          dispatch('setSnackBarText', {
            snackBarText: error,
            snackBarColor: 'red',
          })
          commit('SET_TASK_STATUS', '')
        })
    },
    fetchConfigurationList({ commit, dispatch }, payload: string) {
      return GlobalService.getConfigurationList(payload)
        .then((response) => {
          commit('SET_JSON_CONFIGURATION_LIST', response.data)
          //console.log('SEQUENCE JSON DATA: ' + JSON.stringify(response.data))
        })
        .catch((error) => {
          dispatch('setSnackBarText', {
            snackBarText: error,
            snackBarColor: 'red',
          })
        })
    },
    addNode({ commit }, payload) {
      commit('ADD_NODE', payload)
    },
    renameNode({ commit }, payload) {
      commit('RENAME_NODE', payload)
    },
    deleteNode({ commit }, payload) {
      commit('DELETE_NODE', payload)
    },
    insertNodeReferencesOrClone({ commit }, payload) {
      commit('INSERT_NODE_REFERENCES_OR_CLONE', payload)
    },
    setSelectedNodeViaID({ commit }, payload) {
      commit('SET_SELECTED_NODE_VIA_ID', payload)
    },
    setSelectedNodeFocusViaID({ commit }, payload) {
      commit('SET_SELECTED_NODE_FOCUS_VIA_ID', payload)
    },
    setInitialIDCounter({ commit }, payload: number) {
      commit('SET_INITIAL_ID_COUNTER', payload)
    },
    setInitialConfigsIDCounter({ commit }, payload: number) {
      commit('SET_INITIAL_CONFIGS_ID_COUNTER', payload)
    },
    incrementIDCounter({ commit }) {
      commit('INCREMENT_ID_COUNTER')
    },
    setOpenFileContent({ commit }, payload: any) {
      commit('SET_OPEN_FILE_CONTENT', payload)
    },
    parseMapToJSONFile({ commit }) {
      commit('PARSE_MAP_TO_JSON_FILE')
    },
    setDarkMode({ commit }, payload: boolean) {
      commit('SET_DARK_MODE', payload)
    },
    setSnackBarText(
      { commit },
      payload: {
        snackBarText: string
        snackBarColor: string
      }
    ) {
      commit('SET_SNACKBAR_TEXT', payload)
    },
    setSnackBarOpen({ commit }, payload: boolean) {
      //console.log('CLOSING SNACKBAR')
      commit('SET_SNACKBAR_OPEN', payload)
    },
    setConfigLoaded({ commit }, payload: boolean) {
      //console.log('setConfigLoaded: ' + payload)
      commit('SET_CONFIG_LOADED', payload)
    },
    setStartLoadingConfig({ commit }, payload: boolean) {
      commit('SET_START_LOADING_CONFIG', payload)
    },
    setConfigsListLoaded({ commit }, payload: boolean) {
      //console.log('setConfigLoaded: ' + payload)
      commit('SET_CONFIGS_LIST_LOADED', payload)
    },
    testAction({ commit }, payload) {
      commit('TEST_ACTION', payload)
    },
  },
  getters: {
    getDBNames(state: MainVuexState): Array<string> {
      return state.dbNames
    },
    getConfigMetadata(state: MainVuexState): ConfigMetaData {
      return state.configMetaData
    },
    getConfiguration(state: MainVuexState): any {
      return state.JSONconfiguration
    },
    getTaskStatus(state: MainVuexState): string {
      return state.taskStatus
    },
    getConfigurationsList(state: MainVuexState): any {
      return state.JSONconfigurationList
    },
    getSelectedNodeType(state: MainVuexState): string {
      return state.selectedNodeType
    },
    getSelectedNodeName(state: MainVuexState): string {
      return state.selectedNodeName
    },
    getSelectedNodeCType(state: MainVuexState): string {
      return state.selectedNodeCType
    },
    getSelectedNodeId(state: MainVuexState): number {
      return state.selectedNodeId
    },
    getSelectedNodeParamLength(state: MainVuexState): number {
      return state.selectedNodeParamLength
    },
    getNodeByName: (state: MainVuexState) => (
      nodeType: string,
      nodeName: string
    ) => {
      /*   console.log('getNodeByName nodeType ' + nodeType)
      console.log('getNodeByName nodeName ' + nodeName)
      console.log(
        'state.topLevelNodeTypeToIdMap ' +
          JSON.stringify(state.topLevelNodeTypeToIdMap[nodeType])
      ) */
      for (let i = 0; i < state.topLevelNodeTypeToIdMap[nodeType].length; i++) {
        //console.log("ID: " + state.topLevelNodeTypeToIdMap[nodeType][i])
        /*  console.log(
          'TOP LEVEL NODE (i): ' +
            JSON.stringify(
              state.configNodesMap[state.topLevelNodeTypeToIdMap[nodeType][i]]
            )
        ) */
        if (
          state.configNodesMap[state.topLevelNodeTypeToIdMap[nodeType][i]]
            .name == nodeName
        )
          return state.configNodesMap[
            state.topLevelNodeTypeToIdMap[nodeType][i]
          ]
      }
      return undefined
    },
    getTreeRefsMap(state: MainVuexState): Object {
      return state.treeRefsMap
    },
    getConfigNodesMap(state: MainVuexState): Object {
      return state.configNodesMap
    },
    getConfigsListNodesMap(state: MainVuexState): Object {
      return state.configsListNodeMap
    },
    getTopLevelNodeNameIds(state: MainVuexState): Object {
      return state.topLevelNodeNameToIdMap
    },
    getTopLevelNodeTypeIds(state: MainVuexState): Object {
      return state.topLevelNodeTypeToIdMap
    },
    getTopLevelNodeNameReferenceIDsMap(state: MainVuexState): Object {
      return state.topLevelNodeNameReferenceIDsMap
    },
    getTopLevelModuleNameToChildrenIDsMap(state: MainVuexState): Object {
      return state.topLevelModuleNameToChildrenIDsMap
    },
    getTopLevelStreamNameToIdMap(state: MainVuexState): Object {
      return state.topLevelStreamNameToIdMap
    },
    getTopLevelDatasetNameToIdMap(state: MainVuexState): Object {
      return state.topLevelDatasetNameToIdMap
    },
    getTopLevelStreamNameReferenceIDsMap(state: MainVuexState): Object {
      return state.topLevelStreamNameReferenceIDsMap
    },
    getTopLevelDatasetNameReferenceIDsMap(state: MainVuexState): Object {
      return state.topLevelDataSetsNameReferenceIDsMap
    },
    getIDCounter(state: MainVuexState): number {
      return state.idCounter
    },
    getOpenNodeIds(state: MainVuexState): Array<number> {
      //console.log('openNodeIds FIRED')
      //console.log('openNodeIds:' + state.openNodeIds)
      //sleep(2000).then(() => {
      //have a little delay to avoid race condition
      //console.log('DELAY CALLED')
      return state.openNodeIds
      //})
    },
    getForcedOpenNodeIds(state: MainVuexState): Array<number> {
      return state.forcedOpenNodeIds
    },
    getForcedActiveNodeType(state: MainVuexState): string {
      //console.log('ACTIVE TYPE CHANGED: ' + state.forcedActiveNodeType)
      return state.forcedActiveNodeType
    },
    getForcedActiveNodeId(state: MainVuexState): number {
      //console.log('FORCED ID: ' + state.forcedActiveNodeId)
      return state.forcedActiveNodeId
    },
    getOpenNodeIdsLength(state: MainVuexState): number {
      //console.log('openNodeIds.length FIRED')
      //console.log('openNodeIds:' + state.openNodeIds)
      return state.openNodeIds.length
    },
    getOpenFileContent(state: MainVuexState): string {
      //console.log('GET OPEN FILE CONTENT: ' + state.getOpenFileContent)
      return state.openFileContent
    },
    getSavedFileContent(state: MainVuexState): string {
      return state.savedFileContent
    },
    getDarkMode(state: MainVuexState): boolean {
      return state.darkMode
    },
    getSnackBarOpen(state: MainVuexState): boolean {
      return state.snackBarOpen
    },
    getSnackBarText(state: MainVuexState): string {
      return state.snackBarText
    },
    getSnackBarColor(state: MainVuexState): string {
      //console.log('SNACKBAR COLOR: ' + state.snackBarColor)
      return state.snackBarColor
    },
    getSelectedNodeSnippetText(state: MainVuexState): string {
      //console.log('SELECTED NODE: ' + state.selectedNodeName)
      //console.log('SELECTED NODE ID: ' + state.selectedNodeId)
      //console.log('SELECTED NODE TYPE: ' + state.selectedNodeType)
      /*       console.log(
        'SELECTED NODE ROOT ID: ' +
          state.configNodesMap[state.selectedNodeId].rootNodeId
      )
      console.log(
        'SELECTED NODE CHILDREN IDS: ' +
          state.configNodesMap[state.selectedNodeId].childrenIds
      )
      console.log(
        'SELECTED NODE CHILDREN: ' +
          state.configNodesMap[state.selectedNodeId].children
      ) */
      if (state.selectedNodeType == 'sequences') {
        return SnippetCreator.getSequenceSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'tasks') {
        return SnippetCreator.getTaskSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'conditionaltasks') {
        return SnippetCreator.getCondTaskSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'paths') {
        return SnippetCreator.getPathSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'endpaths') {
        return SnippetCreator.getEndPathSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'modules') {
        //TODO: check what happens here with added node IDs and children
        /*         console.log('state.selectedNodeId: ' + state.selectedNodeId)
        console.log('state.selectedNodeName: ' + state.selectedNodeName)
        console.log(
          'state.configNodesMap[state.selectedNodeId].ctype: ' +
            state.configNodesMap[state.selectedNodeId].ctype
        )
        console.log(
          'state.configNodesMap[state.selectedNodeId].pytype: ' +
            state.configNodesMap[state.selectedNodeId].pytype
        )
        console.log(
          'state.configNodesMap[state.selectedNodeId].children: ' +
            state.configNodesMap[state.selectedNodeId].children
        ) */
        return SnippetCreator.getModuleSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          Array.from(
            state.topLevelModuleNameToChildrenIDsMap[state.selectedNodeName]
          ),
          state.configNodesMap
        )
      } else if (state.selectedNodeType == 'pset') {
        return SnippetCreator.getPSetSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'esproducers') {
        return SnippetCreator.getESProducerSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'essources') {
        return SnippetCreator.getESSourceSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'services') {
        return SnippetCreator.getServiceSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'switchproducers') {
        return SnippetCreator.getSwitchProducerSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'cpuGpu') {
        return SnippetCreator.getCPUSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      } else if (state.selectedNodeType == 'cpuGpuNested') {
        //here redirect to the parent cpuGpu node
        state.selectedNodeId =
          state.configNodesMap[state.selectedNodeId].parentNodeId
        state.selectedNodeName = state.configNodesMap[state.selectedNodeId].name
        return SnippetCreator.getCPUSnippet(
          state.selectedNodeName,
          state.configNodesMap[state.selectedNodeId].ctype,
          state.configNodesMap[state.selectedNodeId].pytype,
          state.configNodesMap[state.selectedNodeId].children as Array<Object>
        )
      }
      return ''
    },
    getSequencesContainingCurrentNode(state: MainVuexState): Object {
      let sequencesContainingNode = {}

      state.topLevelNodeNameReferenceIDsMap[state.selectedNodeName].forEach(
        (referenceNodeId) => {
          let referenceParentId =
            state.configNodesMap[referenceNodeId].parentNodeId
          if (state.configNodesMap[referenceParentId].type == 'sequences') {
            let parentRootId =
              state.configNodesMap[referenceParentId].rootNodeId
            sequencesContainingNode[parentRootId] =
              state.configNodesMap[referenceParentId].name
          }
        }
      )
      /*   console.log(
        'sequencesContainingNode' + JSON.stringify(sequencesContainingNode)
      ) */
      return sequencesContainingNode
    },
    getDirectPathsContainingCurrentNode(state: MainVuexState): Object {
      let pathsContainingNode = {}

      state.topLevelNodeNameReferenceIDsMap[state.selectedNodeName].forEach(
        (referenceNodeId) => {
          //console.log('REF: ' + referenceNodeId)
          let referenceParentId =
            state.configNodesMap[referenceNodeId].parentNodeId
          if (state.configNodesMap[referenceParentId].type == 'paths') {
            let parentRootId =
              state.configNodesMap[referenceParentId].rootNodeId
            pathsContainingNode[parentRootId] =
              state.configNodesMap[referenceParentId].name
          }
        }
      )
      return pathsContainingNode
    },
    getPathsContainingCurrentNode(state: MainVuexState, getters) {
      let pathsContainingNode = {}
      let sequencesContainingNode = {}
      let pathsContianingSequence = {}

      pathsContainingNode = getters.getDirectPathsContainingCurrentNode
      sequencesContainingNode = getters.getSequencesContainingCurrentNode
      console.log(
        'sequencesContainingNode: ' + JSON.stringify(sequencesContainingNode)
      )
      //TODO: possibly recurse deep up to the root node
      // eslint-disable-next-line no-unused-vars
      for (const [nodeId, nodeName] of Object.entries(
        sequencesContainingNode
      )) {
        state.topLevelNodeNameReferenceIDsMap[nodeName as string].forEach(
          (referenceNodeId) => {
            let referenceParentId =
              state.configNodesMap[referenceNodeId].parentNodeId
            if (state.configNodesMap[referenceParentId].type == 'paths') {
              let parentRootId =
                state.configNodesMap[referenceParentId].rootNodeId
              pathsContianingSequence[parentRootId] =
                state.configNodesMap[referenceParentId].name
            }
          }
        )
        //modulePaths.push(sequencePaths)
        if (Object.keys(pathsContianingSequence).length != 0) {
          pathsContainingNode = Object.assign(
            {},
            pathsContainingNode,
            pathsContianingSequence
          )
        }
      }
      //console.log('ALL MODULE PATHS: ' + JSON.stringify(pathsContainingNode))
      return pathsContainingNode
    },
    getSelectedNodeChildren(state: MainVuexState): Array<Object> | undefined {
      if (state.configNodesMap[state.selectedNodeId] != undefined)
        return state.configNodesMap[state.selectedNodeId].children
      else return undefined
    },
    getSelectedModuleChildrenIds(state: MainVuexState): Array<any> | undefined {
      if (state.configNodesMap[state.selectedNodeId] != undefined)
        return Array.from(
          state.topLevelModuleNameToChildrenIDsMap[state.selectedNodeName]
        )
      else return undefined
    },
    getRightClickedNodeChildren(state: MainVuexState): Array<Object> {
      return state.configNodesMap[state.selectedNodeId].children
    },
    getConfigLoaded(state: MainVuexState): boolean {
      //console.log('CONFIG LOADED: ' + state.configLoaded)
      return state.configLoaded
    },
    getStartLoadingConfig(state: MainVuexState): boolean {
      console.log('START LOADING CONFIG: ' + state.startLoadingConfig)
      return state.startLoadingConfig
    },
    getConfigsListLoaded(state: MainVuexState): boolean {
      //console.log('CONFIG LOADED: ' + state.configsListLoaded)
      return state.configsListLoaded
    },
    getModulesInfo(state: MainVuexState): Array<ConfigNodeBasicInfo> {
      let modulesArray: Array<ConfigNodeBasicInfo> = []
      for (
        let i = 0;
        i < state.topLevelNodeTypeToIdMap['modules'].length;
        i++
      ) {
        modulesArray.push({
          id:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .id,
          type:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .type,
          name:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .name,
          text:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .name,
        })
      }
      return modulesArray
    },
    getModulesInsertInfo(state: MainVuexState): Array<ConfigNodeInsertInfo> {
      let modulesArray: Array<ConfigNodeInsertInfo> = []
      for (
        let i = 0;
        i < state.topLevelNodeTypeToIdMap['modules'].length;
        i++
      ) {
        modulesArray.push({
          id:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .id,
          type:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .type,
          name:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .name,
          text:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .name,
          clone: false,
          cloneName:
            state.configNodesMap[state.topLevelNodeTypeToIdMap['modules'][i]]
              .name + '_clone',
          nodeAlreadyExists: false,
        })
      }
      return modulesArray
    },
    getPrescaleHeaders(state: MainVuexState): Array<String> {
      let headerJSON: Object = {}
      let rowsJSON: Object = {}
      if (state.prescaleTableHeaders.length == 0) {
        for (
          let i = 0;
          i < state.topLevelNodeTypeToIdMap['services'].length;
          i++
        ) {
          if (
            state.configNodesMap[state.topLevelNodeTypeToIdMap['services'][i]]
              .name == 'PrescaleService'
          ) {
            for (
              let j = 0;
              j <
              state.configNodesMap[state.topLevelNodeTypeToIdMap['services'][i]]
                .childrenIds.length;
              j++
            ) {
              let prescaleChildrenId =
                state.configNodesMap[
                  state.topLevelNodeTypeToIdMap['services'][i]
                ].childrenIds[j]
              let psName = state.configNodesMap[
                prescaleChildrenId
              ].name.substring(
                0,
                state.configNodesMap[prescaleChildrenId].name.indexOf(' ')
              )
              /*       console.log(
                'PS NAME: ' + state.configNodesMap[prescaleChildrenId].name
              )
 */
              if (psName == 'lvl1Labels') {
                //console.log('FF')
                headerJSON = state.configNodesMap[prescaleChildrenId]
              }
            }
          }
        }
        //console.log('HEADER JSON: ' + JSON.stringify(headerJSON))
        for (let i = 0; i < headerJSON['paremeterJSONValue'].length; i++) {
          //console.log(headerJSON['paremeterJSONValue'][i])
          state.prescaleTableHeaders.push(headerJSON['paremeterJSONValue'][i])
        }
      }
      return state.prescaleTableHeaders
    },
    getPrescaleRows(state: MainVuexState): Array<Object> {
      let prescalesObject: Object = {}
      for (
        let i = 0;
        i < state.topLevelNodeTypeToIdMap['services'].length;
        i++
      ) {
        if (
          state.configNodesMap[state.topLevelNodeTypeToIdMap['services'][i]]
            .name == 'PrescaleService'
        ) {
          for (
            let j = 0;
            j <
            state.configNodesMap[state.topLevelNodeTypeToIdMap['services'][i]]
              .childrenIds.length;
            j++
          ) {
            let prescaleChildrenId =
              state.configNodesMap[state.topLevelNodeTypeToIdMap['services'][i]]
                .childrenIds[j]
            if (
              state.configNodesMap[prescaleChildrenId].name == 'prescaleTable'
            ) {
              prescalesObject = state.configNodesMap[prescaleChildrenId]
            }
          }
        }
      }
      //parse rows now into Object containing path name and array of values
      for (const [key, value] of Object.entries(prescalesObject)) {
        //
        //console.log('KEY: ' + key)
        //console.log('VALUE: ' + JSON.stringify(value))
        if (key == 'children') {
          for (let i = 0; i < value.length; i++) {
            let psObject1 = value[i]['children'][0]
            let psObject2 = value[i]['children'][1]
            state.prescaleTableRows.push({
              id: value[i]['id'],
              pathName: psObject1['paremeterJSONValue'],
              prescalesArray: psObject2['paremeterJSONValue'],
            })
          }
        }
      }
      return state.prescaleTableRows
    },
  },
})

function cloneNodeHelper(
  nodeObjectMapCopy: Object,
  topLevelNodeNameReferenceIDsMapCopy: Object,
  payload: any
) {
  let cloneNodeObject: Object = Object.assign(
    {},
    nodeObjectMapCopy[payload.rootNodeId]
  )
  cloneNodeObject['name'] = payload.cloneName
  //console.log('CLONE NAME: ' + payload.cloneName)
  cloneNodeObject['id'] = ++state.idCounter
  cloneNodeObject['rootNodeId'] = state.idCounter
  //TODO (MAYBE FOR NOW NOT NECESSARY): go through all the parameters and change the parentnode ID
  cloneNodeObject['referencedByIds'] = []
  nodeObjectMapCopy[cloneNodeObject['parentNodeId']].children.push(
    cloneNodeObject
  )
  //console.log('cloneNodeObject.id:' + cloneNodeObject.id)
  nodeObjectMapCopy[cloneNodeObject['id']] = cloneNodeObject
  state.topLevelNodeTypeToIdMap[cloneNodeObject['type']].push(
    cloneNodeObject['id']
  )
  //console.log('TOP LEVEL SEQUENCE: ' + topLevelNodeName)
  // let referenceIds = state.topLevelNodeNameReferenceIDsMap[topLevelNodeName]
  //console.log('!!!REFERENCE IDS!!!: ' + referenceIds)
  topLevelNodeNameReferenceIDsMapCopy[cloneNodeObject['name']] = []

  //console.log('CLONE: ' + JSON.stringify(cloneNodeObject))
  /*  console.log(
    'nodeObjectMapCopy[cloneNodeObject.id]: ' +
      JSON.stringify(nodeObjectMapCopy[cloneNodeObject.id])
  ) */
  //Utils.sleep(1000)
  /*       let t1 = performance.now()
  console.log('CLONING TOOK: ' + Math.round(t1 - t0) + ' milliseconds') */
  deleteChildrenReferencesHelper(nodeObjectMapCopy, {})
  //let payloadObj = {rootNodeId: cloneNodeObject.rootNodeId, parentId: cloneNodeObject.parentNodeId }

  /*    console.log('rootNodeId: ' + cloneNodeObject.rootNodeId)
  console.log('parentNodeId: ' + payload.rootNodeId) */

  insertNodeReferenceHelper(
    nodeObjectMapCopy,
    topLevelNodeNameReferenceIDsMapCopy,
    {
      rootNodeId: cloneNodeObject['rootNodeId'],
      parentId: payload.parentId,
    }
  )
}

function insertNodeReferenceHelper(
  nodeObjectMapCopy: Object,
  topLevelNodeNameReferenceIDsMapCopy: Object,
  payload: any
) {
  //let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)

  let newChildNodeObject: Object = Object.assign(
    {},
    nodeObjectMapCopy[payload.rootNodeId]
  )
  /*   console.log(
    'newChildNodeObject: ' +
      JSON.stringify(nodeObjectMapCopy[payload.rootNodeId])
  ) */

  //console.log('ROOTNODE ID: ' + payload.rootNodeId)
  newChildNodeObject['id'] = ++state.idCounter
  newChildNodeObject['parentNodeId'] = payload.parentId //parent is the passed parent
  //now get the parent type and decide the node nesting type
  let rootType = nodeObjectMapCopy[payload.rootNodeId].type
  //console.log('GLOBAL PARENT TYPE: ' + globalParentType)
  //adjust the reference global type
  newChildNodeObject['children'] = []
  //connect children to root node children (via references)  
  if (rootType == 'sequences') {
    newChildNodeObject['type'] = 'sequences'
    newChildNodeObject['children'] =
      nodeObjectMapCopy[payload.rootNodeId].children
  } else if (rootType == 'tasks') {
    newChildNodeObject['type'] = 'tasks'
    newChildNodeObject['children'] =
      nodeObjectMapCopy[payload.rootNodeId].children
  } else if (rootType == 'conditionaltasks') {
    newChildNodeObject['type'] = 'conditionaltasks'
    newChildNodeObject['children'] =
      nodeObjectMapCopy[payload.rootNodeId].children
  }
  //console.log('CHILD CHILDREN BEFORE: ' + childNodeObject.children)
  newChildNodeObject['referencedByIds'] = []
  //console.log('CHILD CHILDREN AFTER: ' + childNodeObject.children)
  //add reference to root node references
  console.log('newChildNodeObject: ' + JSON.stringify(newChildNodeObject))
  nodeObjectMapCopy[newChildNodeObject['rootNodeId']].referencedByIds.push(
    newChildNodeObject['id']
  )

  let topLevelNodeName =
    nodeObjectMapCopy[newChildNodeObject['rootNodeId']].name
  //console.log('TOP LEVEL SEQUENCE: ' + topLevelNodeName)
  // let referenceIds = state.topLevelNodeNameReferenceIDsMap[topLevelNodeName]
  //console.log('!!!REFERENCE IDS!!!: ' + referenceIds)
  console.log('topLevelNodeName ' + topLevelNodeName)
  console.log(
    'topLevelNodeNameReferenceIDsMapCopy: ' +
      JSON.stringify(topLevelNodeNameReferenceIDsMapCopy)
  )
  topLevelNodeNameReferenceIDsMapCopy[topLevelNodeName].push(
    newChildNodeObject['id']
  )
  /*      console.log(
    '!!!LENGTH!!!: ' +
      nodeObjectMapCopy[newChildNodeObject.rootNodeId].referencedByIds
        .length
  ) */
  //console.log('newChildNodeObject: ' + JSON.stringify(newChildNodeObject))
  nodeObjectMapCopy[payload.parentId].children.push(newChildNodeObject)
  /*    console.log(
    'REFERENCED ROOT NODE IDS: ' +
      nodeObjectMapCopy[newChildNodeObject.rootNodeId]
        .referencedByIds
  ) */
  //console.log('newChildNodeObject.id:' + newChildNodeObject.id)
  nodeObjectMapCopy[newChildNodeObject['id']] = newChildNodeObject

  //console.log('BBBBBBBBBBBBBBBBBBB')
  deleteChildrenReferencesHelper(nodeObjectMapCopy, {})

  /*     console.log(
    '!!!LENGTH AFTER!!!: ' +
      nodeObjectMapCopy[newChildNodeObject.rootNodeId].referencedByIds
        // .length
  ) */

  //state.configNodesMap = Object.freeze(nodeObjectMapCopy)
}

function deleteChildrenReferencesHelper(
  configNodesMapCopy: Object,
  topLevelNodeNameToIdMapCopy: Object
) {
  //let nodeObjectMapCopy: Object = cloneDeep(state.configNodesMap)

  for (const [nodeName, nodeId] of Object.entries(
    topLevelNodeNameToIdMapCopy
  )) {
    if (state.topLevelNodeNameReferenceIDsMap[nodeName] == undefined) continue

    state.topLevelNodeNameReferenceIDsMap[nodeName].forEach(
      (referenceNodeId) => {
        if (
          configNodesMapCopy[nodeId].type == 'sequences' ||
          configNodesMapCopy[nodeId].type == 'paths' ||
          configNodesMapCopy[nodeId].type == 'tasks' ||
          configNodesMapCopy[nodeId].type == 'conditionaltasks' ||
          configNodesMapCopy[nodeId].type == 'stream' ||
          configNodesMapCopy[nodeId].type ==
            'dataset' /* ||
          topNodeGlobalType == 'moduleNode' */ //TODO: weather to change IDs of children?
        ) {
          configNodesMapCopy[referenceNodeId].children = []
        }
      }
    )
    //state.configNodesMap = Object.freeze(nodeObjectMapCopy)
  }
}

//Function used to recursevly copy the top node information into nested nodes
//Used for Paths and Sequences mostly so they can be deeply searched in proper way
function recursevlyCopyChildren(
  parentId: number,
  childrenCopy: Array<Object>,
  nodeObjectMapCopy: Object,
  topLevelNodeNameReferenceIDsMapCopy: Object,
  topLevelDatasetNameReferenceIDsMapCopy: Object,
  topLevelStreamNameReferenceIDsMapCopy: Object
) {
  let topLevelNodeName = ''

  for (let i = 0; i < childrenCopy.length; i++) {
    //console.log('PARENT ID: ' + parentId)
    let pathInjection = false
    let topLevelNodeNameReferenceIDs = topLevelNodeNameReferenceIDsMapCopy
    let topLevelNodeNameToIds = state.topLevelNodeNameToIdMap
    if (
      nodeObjectMapCopy[parentId] != undefined &&
      nodeObjectMapCopy[parentId].name == 'paths'
    ) {
      pathInjection = true
      topLevelNodeName = childrenCopy[i]['paremeterJSONValue']

      if (nodeObjectMapCopy[parentId].name == 'datasets') {
        topLevelNodeNameReferenceIDs = topLevelDatasetNameReferenceIDsMapCopy
        topLevelNodeNameToIds = state.topLevelDatasetNameToIdMap
      }
    } else topLevelNodeName = childrenCopy[i]['name']

    if (topLevelNodeNameReferenceIDs[topLevelNodeName] != undefined) {
      //get all info through the root node
      let rootNodeId = topLevelNodeNameToIds[topLevelNodeName]
      childrenCopy[i]['rootNodeId'] = rootNodeId
      /*   if (nodeObjectMapCopy[rootNodeId]['type'] == 'sequences')
        numberSequences++
      if (nodeObjectMapCopy[rootNodeId]['type'] == 'modules') numberModules++ */
      childrenCopy[i]['parentNodeId'] = parentId //parent changes to immidiate parent where injected
      childrenCopy[i]['id'] = ++state.idCounter //now change the ID

      topLevelNodeNameReferenceIDs[topLevelNodeName].add(
        //push new ID as a reference
        childrenCopy[i]['id']
      )

      //This is for MODULES, no need for recursion since children exist only
      //on the top level in separate data structure not showing in the tree
      if (
        nodeObjectMapCopy[childrenCopy[i]['rootNodeId']]['children'] ==
        undefined
      ) {
        nodeObjectMapCopy[childrenCopy[i]['id']] = childrenCopy[i]
        continue
      }

      if (
        nodeObjectMapCopy[childrenCopy[i]['rootNodeId']].type == 'sequences' ||
        nodeObjectMapCopy[childrenCopy[i]['rootNodeId']].type == 'paths' ||
        nodeObjectMapCopy[childrenCopy[i]['rootNodeId']].type == 'tasks' || 
        nodeObjectMapCopy[childrenCopy[i]['rootNodeId']].type == 'conditionaltasks'
      ) {
        if (pathInjection) {
          childrenCopy[i]['children'] =
            nodeObjectMapCopy[childrenCopy[i]['rootNodeId']].children
        } else {
          let childrenChildrenCopy: Array<Object> = nodeObjectMapCopy[
            childrenCopy[i]['rootNodeId']
          ].children.map((element) => Object.assign({}, element))

          recursevlyCopyChildren(
            childrenCopy[i]['id'],
            childrenChildrenCopy,
            nodeObjectMapCopy,
            topLevelNodeNameReferenceIDsMapCopy,
            topLevelDatasetNameReferenceIDsMapCopy,
            topLevelStreamNameReferenceIDsMapCopy
          )
          childrenCopy[i]['children'] = childrenChildrenCopy.map((element) =>
            Object.assign({}, element)
          )
        }
      }
    } else {
      //This is for DATASETS
      if (childrenCopy[i]['name'] == 'paths') {
        let childrenChildrenCopy: Array<Object> = nodeObjectMapCopy[
          childrenCopy[i]['id']
        ].children.map((element) => Object.assign({}, element))

        recursevlyCopyChildren(
          childrenCopy[i]['id'],
          childrenChildrenCopy,
          nodeObjectMapCopy,
          topLevelNodeNameReferenceIDsMapCopy,
          topLevelDatasetNameReferenceIDsMapCopy,
          topLevelStreamNameReferenceIDsMapCopy
        )

        childrenCopy[i]['children'] = childrenChildrenCopy.map((element) =>
          Object.assign({}, element)
        )
      }
    }
    nodeObjectMapCopy[childrenCopy[i]['id']] = childrenCopy[i]
  }
}
